export const themes = {
    youtube: {
        main1: "#0F0F0F",
        main3: "#181818",
        main4: "#272727",
        main7: "#fc3939",
        white: "#FFFFFF",
        textOff: "#AAAAAA",
    },
    blue: {
        main1: "#0A1024",
        main3: "#151d3a",
        main4: "#2C3A63",
        main7: "#387BFF",
        white: "#F1F5F9",
        textOff: "#94A3B8",
    },
    green: {
        main1: "#061618",
        main3: "#0D2B2E",
        main4: "#184045",
        main7: "#14B8A6",
        white: "#F0FAFA",
        textOff: "#7A999B",
    },
    amber: {
        main1: "#191206",
        main3: "#2E220F",
        main4: "#45341D",
        main7: "#F59E0B",
        white: "#FAF6F0",
        textOff: "#A1917A",
    },
    purple: {
        main1: "#120014",
        main3: "#1D0A22",
        main4: "#2A1430",
        main7: "#C850C0",
        white: "#F4F0F7",
        textOff: "#BFAEC0",
    }
}